import { render } from "./StonesFormStep2.vue?vue&type=template&id=9ab9942a&scoped=true&lang=html"
import script from "./StonesFormStep2.vue?vue&type=script&lang=js"
export * from "./StonesFormStep2.vue?vue&type=script&lang=js"

import "./StonesFormStep2.vue?vue&type=style&index=0&id=9ab9942a&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ab9942a"]])

export default __exports__